// The schedule-call screen's "Not ready to pick a time?" button label —
// gated on `quote-policy-schedule-call-deferral-copy` (flags.ts). That
// gate books a lot of calls, so its wording changes only deliberately.

import type { ScheduleCallDeferralCopyVariant } from "./flags";

export const DEFERRAL_COPY_CONTROL = "Continue application online \u2192";
export const DEFERRAL_COPY_TEST = "Continue to my quote \u2192";

export function deferralButtonLabel(
  variant: ScheduleCallDeferralCopyVariant,
): string {
  return variant === "test" ? DEFERRAL_COPY_TEST : DEFERRAL_COPY_CONTROL;
}
